import axios from "axios";
import { getTokenhn } from "./hntoken";

const hnrequest = axios.create({
    // baseURL: 'http://api.ddspp.com:30123/v2',   
    // baseURL: 'https://shengcong.sh3.ikuai7.com/v2',   
    baseURL: 'http://ddspp.vip:30123/v2',
    timeout: 0
})
// https://shengcong.sh3.ikuai7.com/
//添加请求拦截器 在请求前插入一些自定义配置
hnrequest.interceptors.request.use((config) => {
    const token = getTokenhn()
    if (token) {
        config.headers.Authorization = `{"hn_ddspp":"${token}"}`
    }
    return config
}, (error) => {
    return Promise.reject(error)
})
//添加响应拦截器  在响应返回到客户端之前 做拦截 重点处理返回的数据
hnrequest.interceptors.response.use((response) => {
    return response.data

}, (error) => {
    return Promise.reject(error)
})


export { hnrequest }